import React from 'react';
import { Link } from "gatsby"

import {
  Menu,
  Button,
} from 'semantic-ui-react';

export default function NavItemLogin(props) {
  //console.log('NavItemLogin - props', props);

  //const textColor = props.textColor ? props.textColor : props.header_text_color ? props.header_text_color : null;
  
  return (
    <>
      {/* <style dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize([
          '#layout-wrapper a.ui.button.postUpSignUpButton {',
          '  color: '+ textColor +';',
          '  box-shadow: inset 0 0 0 2px '+ textColor +' !important;',
          '}',
          '#layout-wrapper a.ui.button.postUpSignUpButton:hover {',
          '  color: '+ props.header_background_color +' !important;',
          '  background: '+ textColor +' !important;',
          '}'
          ].join('\n'))
        }}>
      </style> */}
      {(() => {
        switch(props.pageArea) {
          case 'mobile-sidebar-nav':
            return (
              <Menu.Item key={props.id} className={'login-wrapper'}>
                <Button primary icon={props.icon.iconName} labelPosition={props.icon.iconLabelPosition} className={'login-button'}
                  style={{ color: props.textColor ? props.textColor : null, }}
                  as={props?.internalLink.url !== null ? Link : props.externalLink.url !== null ? 'a' : null}
                  to={props?.internalLink.url !== null ? props.internalLink.url : null}
                  href={props?.externalLink?.url ? props.externalLink.url : null}
                  target={props?.externalLink?.url ? '_blank' : null}
                  rel={props?.externalLink?.url ? 'noreferrer' : null}
                  content={props.text}
                />
              </Menu.Item>
            );
          case 'main-nav-container':
            return (
              <Menu.Item key={props.id} className={'login-wrapper'}>
                <Button primary icon={props.icon.iconName} labelPosition={props.icon.iconLabelPosition} className={'login-button'}
                  style={{ color: props.textColor ? props.textColor : null, }}
                  as={props?.internalLink.url !== null ? Link : props.externalLink.url !== null ? 'a' : null}
                  to={props?.internalLink.url !== null ? props.internalLink.url : null}
                  href={props?.externalLink?.url ? props.externalLink.url : null}
                  target={props?.externalLink?.url ? '_blank' : null}
                  rel={props?.externalLink?.url ? 'noreferrer' : null}
                  content={props.text}
                />
              </Menu.Item>
            );
          default:
            return null;
        }
      })()}
    </>
  )
}
